import * as React from 'react';
import styled, { css } from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

export interface SimpleDropdownItemProps {
  className?: string;
  children?: any;
  active?: boolean;
  onClick?: () => void;
}

const SimpleDropdownItem: React.FC<SimpleDropdownItemProps> = (props) => {
  return (
    <Flex
      className={props.className}
      alignItems="center"
      onClick={() => (props.onClick ? props.onClick() : null)}
    >
      <Flex
        flexDirection="row"
        className="dropdown-item-wrapper"
        alignItems="center"
      >
        <Flex flexDirection="column" className="dropdown-item-wrapper">
          <Flex flexDirection="row" className={`dropdown-item-wrapper w-100`}>
            <Typography className="dropdown-item-text" weight="700">
              {props.children}
            </Typography>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default styled(SimpleDropdownItem)`
  position: relative;
  padding-block-end: 8px;
  flex-grow: 0;
  cursor: pointer;
  width: 100%;
  background-color: transparent;
  padding: 10px;
  isolation: isolate;

  .dropdown-item-text {
    color: ${(props) =>
      props.active
        ? css`
            ${({ theme }) => theme.colors.black}
          `
        : css`
            ${({ theme }) => theme.colors.secondaryDark}
          `};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    opacity: 1;
  }
`;
